"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// MIT © 2017 azu
var map_like_1 = require("map-like");
// ====
// Note: This module doesn't show warning in production
// ====
/**
 * Warning: check strict updating for each store
 * In strict mode, whenever Store state is mutated outside of mutation handlers, show warning error.
 * This ensures that all state mutations can be explicitly tracked by almin.
 *
 * https://github.com/almin/almin/issues/201
 */
var StoreGroupChangingStoreStrictChecker = /** @class */ (function () {
    function StoreGroupChangingStoreStrictChecker() {
        // white list for allowing to update
        this.allowedChangingStoreMap = new map_like_1.MapLike();
    }
    /**
     * allow `store` to update
     */
    StoreGroupChangingStoreStrictChecker.prototype.mark = function (store) {
        this.allowedChangingStoreMap.set(store, true);
    };
    /**
     * Is this `store` allowed to update?
     */
    StoreGroupChangingStoreStrictChecker.prototype.isMarked = function (store) {
        return this.allowedChangingStoreMap.has(store);
    };
    /**
     * disallow `store` to update
     */
    StoreGroupChangingStoreStrictChecker.prototype.unMark = function (store) {
        this.allowedChangingStoreMap.delete(store);
    };
    /**
     * Warning: Show warning message if the `store` is not allowed update.
     * We recommenced to update the `store` in `Store#receivePayload` implementation.
     *
     * ## Example
     *
     * ```js
     * class MyStore extends Store {
     *  receivePayload(){
     *    this.setState({ newState });
     *  }
     * }
     * ```
     */
    StoreGroupChangingStoreStrictChecker.prototype.warningIfStoreIsNotAllowedUpdate = function (store) {
        if (!this.isMarked(store)) {
            // TODO: should we support async update in receivePayload?
            console.error("Warning(Store): " + store.name + " can only update own state in " + store.name + "#receivePayload in strict mode.\nIf you update the state outside of " + store.name + "#receivePayload, please check the " + store.name + ".\nSee https://almin.js.org/docs/en/strict-mode.html\n");
        }
    };
    return StoreGroupChangingStoreStrictChecker;
}());
exports.StoreGroupChangingStoreStrictChecker = StoreGroupChangingStoreStrictChecker;
//# sourceMappingURL=StoreGroupChangingStoreStrictChecker.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/UILayer/StoreGroupChangingStoreStrictChecker.js
// module id = 471
// module chunks = 0